import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { FormlyFieldConfig, FormlyFormOptions } from '@ngx-formly/core';
import { TranslateService } from '@ngx-translate/core';
import { NgxPermissionsService } from 'ngx-permissions';
import { MessageService } from 'primeng/api';
import { AccessTokenService, AjaxService, AuthService, FormValidationService, UtilityService } from 'src/app/core';
import { AppLoadService } from 'src/app/core/services/app-load.service';
import { CommonDataService } from 'src/app/core/services/common-data.service';
import { constants } from 'src/app/shared/constants';
import { LoginWrapper1Component } from './login-wrapper1.component';
import { Subscription, interval } from 'rxjs';

@Component({
  selector: 'app-login-screen',
  templateUrl: './login-screen.component.html',
  styleUrls: ['./login-screen.component.less']
})
export class LoginScreenComponent implements OnInit {

  @Input() config: any;
  constructor(private _translateService: TranslateService,
    private _formValidationService: FormValidationService,
    private _ajaxService: AjaxService,
    private _authService: AuthService,
    private _router: Router,
    private _acessTokenService: AccessTokenService,
    private _utilityService: UtilityService,
    private _messageService: MessageService,
    private _dataService: CommonDataService) { }
  form = new FormGroup({});
  model: any = {};
  options: FormlyFormOptions = {};
  fields: FormlyFieldConfig[] = [];
  isESendOtpClicked = false;
  showAuthenticationPopup: boolean = false;
  showVerifyOTPPopup: boolean = false;
  selectedValue = 'email';
  userEmail: String = '';
  userMobile: String = '';
  otp: String= '';
  timer: number = 0;
  intervalSubscription: Subscription | undefined;


  ngOnInit(): void {
    this.loginForm();
    this.checkIfSessionExists();
  }
  ngOnDestroy(): void {
    // Clean up to prevent memory leaks
    this.stopTimer();
  }
  startTimer(): void {
    this.timer = 30; // Set your desired timer duration in seconds
    this.intervalSubscription = interval(1000).subscribe(() => {
      if (this.timer > 0) {
        this.timer--;
      } else {
        this.stopTimer();
      }
    });
  }
  stopTimer(): void {
    if (this.intervalSubscription) {
      this.intervalSubscription.unsubscribe();
      this.intervalSubscription = undefined;
    }
  }

  loginForm() {
    this.fields = [
      {
        key: 'username',
        type: 'input',
        wrappers: ['loginWrapper1'],
        templateOptions: {
          label: 'EMAIL ADDRESS',
          required: true,
        },
        expressionProperties: {
          'templateOptions.label': this._translateService.stream('LblEmailAddressPhone'),
        }
      },
      {
        key: 'password',
        type: 'input',
        wrappers: ['loginWrapper'],
        templateOptions: {
          label: 'PASSWORD',
          type: 'password',
          required: true
        },
        expressionProperties: {
          'templateOptions.label': this._translateService.stream('LblPassword'),
        }
      },
      // {
      //   className: 'otpGrp',
      //   expressionProperties: {
      //   },
      //   fieldGroup: [
      //     {
      //       key: 'tfaCode',
      //       type: 'otp-generation',
      //       templateOptions: {
      //         type: 'number',
      //         disableAutoFocus: true
      //         // onOtpChange: (value: any) => {
      //         //   this.send(value);
      //         // }
      //       },
      //       expressionProperties: {
      //         'templateOptions.placeholder': this._translateService.stream('LblOTP')
      //       }
      //     },
      //     {
      //       type: 'button',
      //       className: 'send-otp-button',
      //       templateOptions: {
      //         onClick: ($event: any) => this.sendEOtp($event),
      //       },
      //       expressionProperties: {
      //         'templateOptions.text': this._translateService.stream('LblSendOtp'),
      //       }
      //     }
      //   ]
      // }
    ];
  }
  
  onOtpChange($event: any) {
    this.otp=$event;
    console.log(this.otp);
  }

  sendEOtp(event: any) {
    if (!this.model.username) {
      this._messageService.add({ severity: 'warn', summary: 'Warning', detail: 'Please Enter Email Address or Phone' });
      return;
    }

    if (this.model.username.includes('@')) {
      this._dataService.isLoading = true;
      const req = {
        type: 'email',
        username: this.model.username,
        password: this.model.password
      }
      this._ajaxService.post('/auth/getUserInfo', req).subscribe((response) => {
        console.log(response);
        if(response.success){
          this._dataService.isLoading = false;
          this.userEmail = response.data.email;
          this.userMobile = response.data.mobile;
          this.showAuthenticationPopup = true;
        }else{
          this._utilityService.showError(response.error);
          this._dataService.isLoading =false;
        }

      })
    } else {
      this._dataService.isLoading = true;
      const req = {
        type: 'mobile',
        username: this.model.username,
        password: this.model.password
      }
      this._ajaxService.post('/auth/getUserInfo', req).subscribe((response) => {
        console.log(response);
        if(response.success){
          this._dataService.isLoading = false;
          this.userEmail = response.data.email;
          this.userMobile = response.data.mobile;
          this.showAuthenticationPopup = true;
        }else{
          this._utilityService.showError(response.error);
          this._dataService.isLoading =false;
        }

      })
    }
  }

  async sendOtp(){
    this.startTimer();
    this.showAuthenticationPopup=false;
    const data = {
      username: this.model.username,
      password: this.model.password,
      otpType: this.selectedValue
    }
    this._dataService.isLoading = true;
    this._ajaxService.post('/auth/genrateTFACode', data).subscribe((response) => {
      const result = response.data;

      this._dataService.isLoading = false;
      this.showVerifyOTPPopup = true;
      if (response.success) {
        this.isESendOtpClicked = true;
        this._messageService.add({ severity: 'success', summary: constants.AUTHENTICATION_CODE, detail: constants.AUTHENTICATION_CODE + ' Sent Successfully.' });
      } else {
        this._utilityService.showError(response.error);
      }
    });
  }
  checkIfSessionExists() {
    if (this._acessTokenService.getTokenDetails(false)) {
      this._router.navigate(['landing/summary']);
    }
  }
  loginAction() {
    let value = { ...this.model };
    value['otpType'] = this.selectedValue;
    this._formValidationService.markFormGroupTouched(this.form);
    if (this.form.valid) {
      this.sendEOtp(null);
    }
  }
  loginClicked() {
    let value = { ...this.model };
    value['otpType']=this.selectedValue;
    this._formValidationService.markFormGroupTouched(this.form);
    if (this.form.valid) {
      if (!this.otp || this.otp.length < 4) {
        this._messageService.add({ severity: 'warn', summary: 'Warning', detail: 'Please Enter ' + constants.AUTHENTICATION_CODE });
        return;
      }
      value.tfaCode = this.otp;
      this._dataService.isLoading = true;
      this._ajaxService.post('/auth/login', value).subscribe((response) => {
        this._dataService.isLoading = false;
        if (response.success) {
          const result = response.data;
          this._authService.setSession(result.access_token);
          this._router.navigate(['/landing/summary']);
        } else {
          this._utilityService.showError(response.error);
        }
      },
        error => {
          this._dataService.isLoading = false;
        });
    }
  }
  get isModal() {
    return true;
  }
  checkBoxChecked(type: String) {
    switch (type) {
      case 'email': {
        this.selectedValue = 'email';
        break;
      }
      case 'sms': {
        this.selectedValue = 'sms';
        break;
      }
      case 'call': {
        this.selectedValue = 'call';
        break;
      }
    }

  }

  navigateToJoinMeeting(){
    this._router.navigate(['/home/join-meeting']);
  }
}
